import React from "react";
import PropTypes from "prop-types";

import { K_LETTER_SPACING, K_COLORS_LIGHT_GREY } from "../../constants";

const BrandName = (props) => {
  const { name } = props;

  return <span style={styles.brandName}> {name} </span>;
};

const styles = {
  brandName: {
    color: K_COLORS_LIGHT_GREY,
    letterSpacing: K_LETTER_SPACING,
    fontWeight: "bold",
    display: "inline-block",
    marginLeft: "1rem",
    fontSize: "1.2rem",
  },
};

BrandName.propTypes = {
  name: PropTypes.string.isRequired,
};

export default BrandName;
